import React from 'react'

import { Text } from '@plurall/elo-beta'
import { TableCell } from 'App/components/TableCell'

const responsibleStudentsTableHeader = [
  {
    id: 1,
    value: 'N°',
  },
  {
    id: 2,
    value: 'Aluno',
    width: 180,
  },
  {
    id: 3,
    value: 'Escola',
    width: 180,
  },
  {
    id: 4,
    value: 'Segmentos',
    width: 220,
  },
  {
    id: 5,
    value: 'Ações',
    width: 80,
  },
]

const onlyUnique = (value, index, array) => {
  return array.indexOf(value) === index
}
const formatArrayToPluralize = arrayOfStrings => {
  const onlyUniqueArrayOfStrings = arrayOfStrings.filter(onlyUnique)

  if (onlyUniqueArrayOfStrings.length < 3) {
    return onlyUniqueArrayOfStrings.join(' e ')
  }

  if (onlyUniqueArrayOfStrings.length >= 3) {
    const lastItem = onlyUniqueArrayOfStrings.pop()
    return `${onlyUniqueArrayOfStrings.join(', ')} e ${lastItem}`
  }
}

const responsibleStudentsTableDataFormat = (students, openRemoveRelatedStudentAlert) =>
  students.map(({ id, name, person: { schools } }, index) => {
    let formattedLevels
    let formattedSchoolName
    let studentLevels = []
    let studentSchoolNames = []

    schools.forEach(({ studentData: { classes }, tradeName, legalName }) => {
      if (!classes?.length) {
        return
      }

      studentSchoolNames.push(tradeName || legalName)

      classes.forEach(classItem => {
        if (classItem) {
          const { levelGrades } = classItem
          const newLevels = levelGrades.map(({ levelName }) => `${levelName}`)

          studentLevels = [...studentLevels, ...newLevels]
        }
      })
    })

    formattedSchoolName = formatArrayToPluralize(studentSchoolNames)
    formattedLevels = formatArrayToPluralize(studentLevels)

    return {
      id: index + 1,
      cells: [
        {
          id: 1,
          children: (
            <TableCell
              title={name}
              cellWidth={180}
              dataTestId={`responsible-students-table-name-${index + 1}`}
            />
          ),
        },
        {
          id: 2,
          children: (
            <TableCell
              title={formattedSchoolName}
              cellWidth={180}
              dataTestId={`responsible-students-table-school-${index + 1}`}
            />
          ),
        },
        {
          id: 3,
          children: (
            <TableCell
              title={formattedLevels}
              cellWidth={200}
              dataTestId={`responsible-students-table-level-${index + 1}`}
            />
          ),
        },
        {
          id: 4,
          children: (
            <Text
              size={'t3'}
              element={'a'}
              variant={'negative'}
              dataTestId={`responsible-students-table-remove-related-user-${index + 1}`}
              onClick={() => openRemoveRelatedStudentAlert(id, name)}
            >
              Desvincular
            </Text>
          ),
        },
      ],
      menu: [],
    }
  })

export { responsibleStudentsTableHeader, responsibleStudentsTableDataFormat }
